import React, { useContext } from 'react'

import Link from 'next/link'
import { css } from '@emotion/core'
import flexCenter from 'utils/styles/flexCenter'
import { useTheme } from 'emotion-theming'
import { KampuspediaCtx, KampuspediaStatus } from 'components/utils/KampuspediaProvider'

import Container from 'components/layouts/atoms/Container'
import NewTypography from 'components/common/atoms/NewTypography'
import MarkdownContent from 'components/common/atoms/MarkdownContent'
import Loader from 'components/common/atoms/Loader'
import IndexList from 'components/common/molecules/IndexList'

const kampuspediaIndexStyle = css`
  min-height: 607px;
  .kampuspedia-index {
    &__wrapper {
      padding: 24px 24px 24px 68px;
    }
    &__title {
      display: flex;
      column-gap: 16px;
      margin-bottom: 16px;
    }
    &__note {
      ${flexCenter}
      .campus-markdown-content {
        margin: 0;
      }
    }
    &__button {
      ${flexCenter}
      margin-top: 16px;
    }
  }
  @media screen and (min-width: 768px) {
    min-height: auto;
    .kampuspedia-index {
      &__wrapper {
        padding: 40px 0;
      }
      &__title {
        margin-bottom: 24px;
      }
      &__button {
        margin-top: 40px;
        cursor: pointer;
      }
    }
  }
`

const KampuspediaIndex = () => {
  const theme: ThemeType = useTheme()
  const { state } = useContext(KampuspediaCtx)

  return (
    <div className="kampuspedia-index" css={kampuspediaIndexStyle}>
      <Container isMobileFull>
        <div className="kampuspedia-index__wrapper">
          {state.status !== KampuspediaStatus.completed ? (
            <div className="kampuspedia-index__title">
              <Loader
                dataTestId="kampuspedia-index__title"
                customSize={{
                  sp: {
                    width: 100,
                    height: 24,
                    borderRadius: 10,
                  },
                  pc: {
                    width: 200,
                    height: 24,
                    borderRadius: 10,
                  },
                }}
              />
              <Loader
                dataTestId="kampuspedia-index__note"
                className="kampuspedia-index__note"
                width="inherit"
                customSize={{
                  sp: {
                    width: 160,
                    height: 16,
                    borderRadius: 10,
                  },
                  pc: {
                    width: 300,
                    height: 16,
                    borderRadius: 10,
                  },
                }}
              />
            </div>
          ) : (
            <div className="kampuspedia-index__title">
              <NewTypography tagName="h1" variant="title" level="4" levelPC="3">
                {state.activeIndex}
              </NewTypography>
              <NewTypography
                variant="paragraph"
                level="3"
                levelPC="2"
                color={theme.gray.gray40}
                className="kampuspedia-index__note"
              >
                <MarkdownContent
                  content={`**${state.indexList.indexDetailList.detailList?.length || 0}** dari **${
                    state.indexList.pageInfo?.total || 0
                  }** istilah`}
                />
              </NewTypography>
            </div>
          )}

          <IndexList
            list={state.indexList.indexDetailList.detailList}
            url="/kampuspedia/"
            loading={state.status !== KampuspediaStatus.completed}
          />

          {state.status !== KampuspediaStatus.completed ? (
            <Loader
              dataTestId="kampuspedia-index__button"
              className="kampuspedia-index__button"
              customSize={{
                sp: {
                  width: 276,
                  height: 15,
                  borderRadius: 10,
                },
                pc: {
                  width: 1190,
                  height: 16,
                  borderRadius: 10,
                },
              }}
            />
          ) : (
            <Link
              className="kampuspedia-index__button"
              href={`/kampuspedia/group/${encodeURIComponent(state.activeIndex.toLowerCase())}`}
            >
              <NewTypography variant="heading" level="2" levelPC="1" color={theme.campus.aqua30}>
                Lihat Istilah Lainnya
              </NewTypography>
            </Link>
          )}
        </div>
      </Container>
    </div>
  )
}

export default KampuspediaIndex
